export function getRandomHardwareLoadingMessage(): string {
  const loadingMessages = [
    "Counting screws and motherboards",
    "Tightening the bolts on your inventory",
    "Untangling the cables",
    "Flipping through floppy disks for stock info",
    "Polishing the rack mounts",
    "Plugging everything in just to unplug it again",
    "Convincing the printer to cooperate",
    "Rebooting reality (please wait)",
    "Checking if we have enough duct tape for repairs",
  ];
  const randomIndex = Math.floor(Math.random() * loadingMessages.length);
  return loadingMessages[randomIndex];
}
